module.exports = __webpack_public_path__ + "img/icon_plus.481b27eb.svg";